<template>
    <div>
        <el-row>
            <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                    <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                </el-tooltip>
            </el-col>
            <el-col :span="12">
                <h3><span v-show="!create">修改接口</span><span v-show="create">新增接口</span></h3>
            </el-col>
        </el-row>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-form-item label="接口代码" prop="apiCode">
                        <el-input ref="ipt01" v-model="form.apiCode" placeholder="请输入" maxlength="20" show-word-limit
                            :disabled="!create"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="接口名称" prop="apiName">
                            <el-input ref="ipt02" v-model="form.apiName" placeholder="请输入" maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="接口类" prop="apiClass">
                            <el-input ref="ipt03" v-model="form.apiClass" placeholder="请输入" maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="解析方法" prop="apiMethod">
                            <el-input ref="ipt04" v-model="form.apiMethod" placeholder="请输入" maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否可为空" prop="isNull">
                            <el-select v-model="form.isNull">
                                <el-option label="是 " value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否验证身份" prop="isIdentity">
                            <el-select v-model="form.isIdentity">
                                <el-option label="是 " value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="有效标志" prop="isValid">
                            <el-select v-model="form.isValid">
                                <el-option label="是 " value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="序号" prop="displaySeq">
                            <el-input ref="ipt05" v-model="form.displaySeq" placeholder="请输入" maxlength="10" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
   // import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity"],
        data() {
            var checkApiCode = (rule, value, callback) => {
                const reg = /^[0-9A-Za-z]*$/;
                if (!reg.test(value)) {
                    callback(new Error("接口代码只能是数字和字母组成"));
                } else {
                    callback();
                }
            };
            var checkApiClass = (rule, value, callback) => {
                const reg = /^[0-9A-Za-z.]*$/;
                if (!reg.test(value)) {
                    callback(new Error("接口类只能是数字、字母和点组成"));
                } else {
                    callback();
                }
            };
            var checkApiMethod = (rule, value, callback) => {
                const reg = /^[0-9A-Za-z]*$/;
                if (!reg.test(value)) {
                    callback(new Error("解析方法只能是数字和字母组成"));
                } else {
                    callback();
                }
            };
            var checkDisplaySeq = (rule, value, callback) => {
                const reg =  /^\+?[1-9]\d*$/;
                if (!reg.test(value)) {
                    callback(new Error("序号只能是数字"));
                } else {
                    callback();
                }
            };
            let create = !this.entity.apiCode
            let form
            if (create) {
                form = {
                    apiCode: "",
                    apiName: "",
                    apiClass: "",
                    apiMethod: "",
                    isNull: "N",
                    isIdentity: "Y",
                    isValid: "Y",
                    displaySeq: ""

                }
            } else {
                form = Object.assign({}, this.entity)
                console.log(this.entity)
            }
            let data = {
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                create,
                einvtypeCodeOptions: [],
                form,
                formRules: {
                    apiCode: [{
                            required: true,
                            message: "请输入接口代码",
                            trigger: "blur"
                        }, {
                            validator: checkApiCode,
                            trigger: "blur"
                        },
                        {
                            max: 20,
                            message: "最多20个字符",
                            trigger: "blur"
                        }
                    ],
                    apiName: [{
                            required: true,
                            message: "请输入接口名称",
                            trigger: "blur"
                        },
                        {
                            max: 100,
                            message: "最多100个字符",
                            trigger: "blur"
                        }
                    ],
                    apiClass: [{
                            required: true,
                            message: "请输入接口类",
                            trigger: "blur"
                        }, {
                            validator: checkApiClass,
                            trigger: "blur"
                        },
                        {
                            max: 500,
                            message: "最多500个字符",
                            trigger: "blur"
                        }
                    ],
                    apiMethod: [{
                            required: true,
                            message: "请输入解析方法",
                            trigger: "blur"
                        }, {
                            validator: checkApiMethod,
                            trigger: "blur"
                        },
                        {
                            max: 500,
                            message: "最多500个字符",
                            trigger: "blur"
                        }
                    ],
                    isNull: [{
                        required: true,
                        message: "请选择是否可为空",
                        trigger: "blur"
                    }],
                    isIdentity: [{
                        required: true,
                        message: "请选择是否验证身份",
                        trigger: "blur"
                    }],
                    isValid: [{
                        required: true,
                        message: "请选择有效标志",
                        trigger: "blur"
                    }],
                    displaySeq: [{
                            required: true,
                            message: "请输入序号",
                            trigger: "blur"
                        }, {
                            validator: checkDisplaySeq,
                            trigger: "blur"
                        }
                        // ,
                        // {
                        //     max: 10,
                        //     message: "最多10个字符",
                        //     trigger: "blur"
                        // }
                    ]
                }
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit()
            },
            // queryYyOption() {
            //     _kits.api.call("SELECTJKYY", {}, result => {
            //         if (result.returnCode == "0000") {
            //             console.log("queryDlOption", "result", result);
            //             this.yyOptions = result.data;
            //             if (this.form.jkyyDm == "" && result.data.length > 0) {
            //                 this.form.jkyyDm = result.data[0].jkyyDm;
            //             }
            //         } else {
            //             this.$message.error(result.returnMsg);
            //         }
            //     });
            // },
            // queryDlOption() {
            //     _kits.api.call("SELECTJKDL", {}, result => {
            //         if (result.returnCode == "0000") {
            //             console.log("queryDlOption", "result", result);
            //             this.dlOptions = result.data;
            //             if (this.form.jkdlDm == "" && result.data.length > 0) {
            //                 this.form.jkdlDm = result.data[0].jkdlDm;
            //             }
            //             this.queryXlOption();
            //         } else {
            //             this.$message.error(result.returnMsg);
            //         }
            //     });
            // },
            // queryXlOption() {
            //     if (this.form.jkdlDm == "") {
            //         this.xlOptions = [];
            //         return;
            //     }
            //     _kits.api.call(
            //         "SELECTJKXL", {
            //             jkdlDm: this.form.jkdlDm
            //         },
            //         result => {
            //             if (result.returnCode == "0000") {
            //                 console.log("queryXlOption", "result", result);
            //                 this.xlOptions = result.data;
            //                 if (this.form.jkxlDm == "" && result.data.length > 0) {
            //                     this.form.jkxlDm = result.data[0].jkxlDm;
            //                 }
            //             } else {
            //                 this.$message.error(result.returnMsg);
            //             }
            //         }
            //     );
            // }
        },
        created() {
            _kits = this.$kits();
            //this.queryYyOption();
            //this.queryDlOption();

        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "ADDAPIDETAILS" : "UPDATEAPIDETAILS"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
            //*/
        }
    }
</script>
